import React from 'react'
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Grid,
    LinearProgress,
} from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import MobileStepper from '@mui/material/MobileStepper'
import IconButton from '@mui/material/IconButton'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import { Traduccion } from '../Traduccion'
import { getLastTenantUser, setLastTenantUser, getFinRestriccionEmailRecuperacion, setFinRestriccionEmailRecuperacion } from '../../config/Storage'
import { listarLogos, listarTenantsDisponibles, login, cambiarPass, recuperarCuenta, buscarInfoDeTenant } from '../../services/servUsuarios'
import { InputPassword, InputTexto } from '../Input'
import { Error, Ok } from '../Message'
import { Modal } from '../Modal'
import { Normal } from '../Texto.js'
import { setToken } from '../../config/Sesion.js'

export const LoginCard = ({ onErrors, onSuccess }) => {

    const [user, setUser] = React.useState()

    const _handleUserSubmit = (res) => {
        if (res.errores) {
            onErrors(res.errores[0])
        } else {
            setUser(res.user)
        }
    }

    const _handlePassSubmit = (res) => {
        if (res.return) {
            setUser(null)
        } else if (res.errores) {
            onErrors(res.errores[0])
        } else {
            inicializarSesion(user, res.tenantId, res.token)
            onSuccess()
        }
    }

    const inicializarSesion = (user, tenantId, tokenStr) => {
        setToken(tokenStr)
        setLastTenantUser(user, tenantId)
        buscarInfoDeTenant() //busco sin await, total es para actualizar la caché
    }

    return <Card style={{ maxWidth: 300, margin: '0 auto' }}>
        {!user
            ? <UserCardContent onSubmit={_handleUserSubmit} />
            : <PassCardContent onSubmit={_handlePassSubmit} userData={user} />
        }
    </Card>
}

const UserCardContent = ({ onSubmit }) => {

    const [email, setEmail] = React.useState('')
    const [isLoading, setIsLoading] = React.useState(false)

    const _handleSubmit = (e) => {
        e.preventDefault()
        setIsLoading(true)
        listarTenantsDisponibles(email).then(d => {
            setIsLoading(false)
            onSubmit({
                errores: d.errores,
                user: {
                    email: email,
                    tenants: d.data
                }
            })
        })
    }

    return <div>
        <CardMediaCustom defaultImage />
        {isLoading &&
            <LinearProgress />}
        <form onSubmit={_handleSubmit}>
            <CardContent>
                <InputTexto id="username"
                    name="username"
                    label={Traduccion('TXT_USUARIO')}
                    onChange={setEmail}
                    value={email}
                    disabled={isLoading}
                    autoComplete="username"
                    maxLength={50}
                    fullWidth
                    autoFocus
                />
            </CardContent>
            <CardActions sx={{ justifyContent: 'center' }}>
                <Button variant="contained" color="primary" type="submit" disabled={isLoading}>
                    {Traduccion('TXT_SIGUIENTE')}
                </Button>
            </CardActions>
            <br />
        </form>
    </div>
}

const PassCardContent = ({ onSubmit, userData }) => {

    const [pass, setPass] = React.useState('')
    const [isLoading, setIsLoading] = React.useState(false)
    const [selectedTenantId, setSelectedTenantId] = React.useState()

    const [formNuevoPass, setFormNuevoPass] = React.useState({
        cambiar: false,
        nuevoPass: '',
        nuevoPassCheck: '',
        enviado: false
    })

    const [recuperacionCuenta, setRecuperacionCuenta] = React.useState({
        showModal: false,
        buttonDisabledFor: 0
    })
    const timerRef = React.useRef(null)

    const updFormNuevoPass = (val, id) => setFormNuevoPass({ ...formNuevoPass, [id]: val })

    const validacionesNuevoPass = [{
        nombre: 'ERR_PASS_LONGITUD',
        val: formNuevoPass.nuevoPass.length < 8 || formNuevoPass.nuevoPass.length > 20
    }, {
        nombre: 'ERR_PASS_NO_SEGURO',
        val: !/^(?=.*[A-Za-z])(?=.*\d).{0,}$/.test(formNuevoPass.nuevoPass)
    }, {
        nombre: 'ERR_PASS_NO_COINCIDEN',
        val: formNuevoPass.nuevoPass !== formNuevoPass.nuevoPassCheck
    }]

    // Al montar, revisa si hay un temporizador guardado y retoma el conteo
    React.useEffect(() => {
        const storedEnd = getFinRestriccionEmailRecuperacion()
        if (storedEnd) {
            const endTime = parseInt(storedEnd)
            const now = Date.now()
            let remaining = Math.max(0, Math.ceil((endTime - now) / 1000))
            if (remaining > 0) {
                setRecuperacionCuenta({ showModal: false, buttonDisabledFor: remaining })
                timerRef.current = setInterval(() => {
                    const newRemaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000))
                    if (newRemaining <= 0) {
                        clearInterval(timerRef.current)
                        setFinRestriccionEmailRecuperacion(undefined)
                    }
                    setRecuperacionCuenta(prev => ({ ...prev, buttonDisabledFor: newRemaining }))
                }, 1000)
            } else {
                setFinRestriccionEmailRecuperacion(undefined)
            }
        }
        return () => {
            clearInterval(timerRef.current)
        }
    }, [])

    const _handleBack = () => onSubmit({ return: true })

    const _handleSubmit = async (e) => {
        e.preventDefault()
        if (formNuevoPass.cambiar) _handleCambiarPass()
        else _handleIniciarSesion()
    }

    const _handleIniciarSesion = () => {
        setIsLoading(true)
        login(userData.email, formNuevoPass.cambiar ? formNuevoPass.nuevoPass : pass, selectedTenantId).then(d => {
            setIsLoading(false)
            if (d.errores?.includes('ERR_CAMBIAR_CONTRASENA')) setFormNuevoPass({ ...formNuevoPass, cambiar: true })
            onSubmit({ tenantId: selectedTenantId, token: d.data, errores: d.errores })
        })
    }

    const _handleCambiarPass = async () => {
        setFormNuevoPass({ ...formNuevoPass, enviado: true })
        if (validacionesNuevoPass.map(e => e.val).some(Boolean)) {
            return
        }
        let resCambio = await cambiarPass(userData.email, pass, formNuevoPass.nuevoPass)
        if (!resCambio.errores) {
            _handleIniciarSesion()
        } else {
            onSubmit({ tenantId: selectedTenantId, token: undefined, errores: resCambio.errores })
        }
    }

    const _handleRecuperarPass = () => {
        recuperarCuenta(userData.email) //sin await, solo me interesa mandar la petición e informar del hecho
        const seconds = 60
        const endTime = Date.now() + (seconds * 1000)
        setFinRestriccionEmailRecuperacion(endTime)
        setRecuperacionCuenta({ showModal: true, buttonDisabledFor: seconds })
        timerRef.current = setInterval(() => {
            const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000))
            if (remaining <= 0) {
                clearInterval(timerRef.current)
                setFinRestriccionEmailRecuperacion(undefined)
            }
            setRecuperacionCuenta(prev => ({ ...prev, buttonDisabledFor: remaining }))
        }, 1000)
    }

    const _handleCloseModalRecuperarCuenta = () => {
        setRecuperacionCuenta(prev => ({ ...prev, showModal: false }))
    }

    return <>
        <TenantSelector userData={userData} isPassSubmitting={isLoading} onTenantChanged={setSelectedTenantId} />
        {isLoading &&
            <LinearProgress />}
        <form onSubmit={_handleSubmit}>
            <CardContent>
                <Box sx={{ textAlign: 'center' }}>
                    <Chip avatar={<Avatar>{userData.email.substring(0, 1).toUpperCase()}</Avatar>}
                        label={userData.email}
                        color="primary"
                        variant="outlined"
                        onDelete={_handleBack}
                        disabled={isLoading} />
                </Box><br />
                <input type="text" name="username" value={userData.email}
                    autoComplete="username" style={{ display: 'none' }} readOnly
                />
                {!formNuevoPass.cambiar &&
                    <InputPassword id="password"
                        name="password"
                        label={Traduccion('TXT_PASS')}
                        onChange={setPass}
                        value={pass}
                        disabled={isLoading}
                        autoComplete="current-password"
                        maxLength={20}
                        fullWidth autoFocus />
                }
                {formNuevoPass.cambiar && <>
                    <InputPassword id="nuevoPass"
                        label={Traduccion('TXT_NUEVO_PASS')}
                        onChange={updFormNuevoPass}
                        value={formNuevoPass.nuevoPass}
                        disabled={isLoading}
                        autoComplete="new-password"
                        validarSubmit={formNuevoPass.enviado}
                        maxLength={20}
                        autoFocus fullWidth required /><br /><br />
                    <InputPassword id="nuevoPassCheck"
                        label={Traduccion('TXT_REPETIR_PASS')}
                        onChange={updFormNuevoPass}
                        value={formNuevoPass.nuevoPassCheck}
                        disabled={isLoading}
                        autoComplete="new-password"
                        validarSubmit={formNuevoPass.enviado}
                        maxLength={20}
                        fullWidth required />
                </>}
                {formNuevoPass.cambiar &&
                    <MensajesNuevaContrasena validaciones={validacionesNuevoPass} />
                }
            </CardContent>
            <CardActions sx={{ justifyContent: 'center' }}>
                <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                    <Grid item>
                        <Button variant="contained" color="primary" type="submit" disabled={isLoading}>
                            {Traduccion('TXT_INICIAR_SESION')}
                        </Button>
                    </Grid>
                    {!formNuevoPass.cambiar &&
                        <Grid item>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button color="primary" disabled={isLoading || !userData.email.includes('@') || recuperacionCuenta.buttonDisabledFor > 0} onClick={_handleRecuperarPass}>
                                    {Traduccion('TXT_RECUPERAR_CONTRASENA')}
                                </Button>
                                <Normal sx={{ color: 'rgba(0, 0, 0, 0.26)' }}>{(recuperacionCuenta.buttonDisabledFor > 0 ? ` (${recuperacionCuenta.buttonDisabledFor}s)` : '')}</Normal>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </CardActions>
            <br />
        </form>
        <Modal isOpen={recuperacionCuenta.showModal}
            onClose={_handleCloseModalRecuperarCuenta}
            title={Traduccion('TXT_RECUPERAR_CONTRASENA')}
            actions={<Button variant="contained" onClick={_handleCloseModalRecuperarCuenta} color="primary">{Traduccion('TXT_ACEPTAR')}</Button>}
            maxWidth='xs'>
            {Traduccion('MSJ_EMAIL_RECUPERAR_CONTRASENA')}
        </Modal>
    </>
}

const MensajesNuevaContrasena = ({ validaciones }) => {

    return <><br /><br />
        {validaciones.map((e, idx) => {
            return (e.val)
                ? <Error key={idx}>{Traduccion(e.nombre)}</Error>
                : <Ok key={idx}>{Traduccion(e.nombre)}</Ok>
        })}
    </>
}

const CardMediaCustom = ({ logo, defaultImage }) => {
    const styles = {
        logo: {
            height: '12.5em',
            width: '100%',
            objectFit: 'cover'
        }
    }
    return defaultImage
        ? <CardMedia image={'logoMain.png'} sx={styles.logo} />
        : logo
            ? <CardMedia image={'data:null;base64,' + logo} sx={styles.logo} />
            : <Skeleton variant="rect" animation="wave" sx={styles.logo} />
}

const TenantSelector = ({ userData, isPassSubmitting = false, onTenantChanged }) => {

    const [selectedTenantIdx, setSelectedTenantIdx] = React.useState(0)
    const [tenantList, setTenantList] = React.useState([])

    const _handleNextTenant = () => {
        const newIndex = selectedTenantIdx + 1
        setSelectedTenantIdx(newIndex)
        onTenantChanged(userData.tenants[newIndex].id)
    }
    const _handlePrevTenant = () => {
        const newIndex = selectedTenantIdx - 1
        setSelectedTenantIdx(newIndex)
        onTenantChanged(userData.tenants[newIndex].id)
    }
    const _maxSteps = () => userData.tenants.length - 1 ?? 0

    React.useEffect(() => {
        let tenantsDisponibles = userData.tenants.map(e=>e)
        setTenantList(tenantsDisponibles)
        //selecciono por defecto el último tenant con el que trabajó el usuario
        //o el primero si no hay ninguno en su lista de disponibles
        let lastTenantId = getLastTenantUser(userData)
        if (!lastTenantId || !tenantsDisponibles.some(e => e.id === lastTenantId)) {
            lastTenantId = tenantsDisponibles[0].id
        }
        setSelectedTenantIdx(tenantsDisponibles.indexOf(tenantsDisponibles.find(e => e.id === lastTenantId)))
        onTenantChanged(lastTenantId)
        //seteo los logos de los tenants
        listarLogos(userData.email, tenantsDisponibles.map(t => t.id)).then(res => {
            setTenantList(res.data)
        })
    }, [userData, onTenantChanged])

    return <>
            {_maxSteps() > 0 &&
            <MobileStepper
                variant="dots"
                steps={tenantList.length}
                position="static"
                activeStep={selectedTenantIdx}
                backButton={
                    <IconButton aria-label="previous" onClick={_handlePrevTenant} disabled={isPassSubmitting || selectedTenantIdx === 0}>
                        <KeyboardArrowLeft />
                    </IconButton>
                }
                nextButton={
                    <IconButton aria-label="next" onClick={_handleNextTenant} disabled={isPassSubmitting || selectedTenantIdx === _maxSteps()}>
                        <KeyboardArrowRight />
                    </IconButton>
                }
            />
            }
            {tenantList.map((t, idx) =>
                selectedTenantIdx === idx && (
                    <CardMediaCustom key={t.id} logo={t.logo} />
                )
            )}
        </>

}